import { Component } from '@angular/core';

@Component({
    selector: 'app-professional-certification-dialog',
    templateUrl: './professional-certification-dialog.component.html',
    styleUrls: ['./professional-certification-dialog.component.scss'],
    standalone: false
})
export class ProfessionalCertificationDialogComponent {
}
